module.exports = __webpack_public_path__ + "media/v2/components/_HowToPlay/shared/PlayerPickemContest/targetGray-0f5016d6d69e22ff228adbf96a2fbf49.svg";